import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, silverChalice} from '/theme/color/on.color';
import {alto, codGray, cyanBlue, malibu} from '/theme/color/secondary.color';

export default StyleSheet.create({
  button: {
    height: 40,
    borderRadius: 24,
    borderColor: alto,
    backgroundColor: alabaster,
    justifyContent: 'center',
    borderWidth: 1,
    paddingHorizontal: 18,
    marginLeft: 10,
  },
  selectedButton: {
    height: 40,
    borderRadius: 24,
    borderColor: malibu,
    backgroundColor: cyanBlue,
    justifyContent: 'center',
    borderWidth: 1,
    paddingHorizontal: 18,
    marginLeft: 10,
  },
  buttonStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  buttonText: {
    color: codGray,
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
  },
  arrowIcon: {
    color: silverChalice,
    fontSize: 20,
    alignSelf: 'center',
    marginLeft: indent * 0.2,
    paddingLeft: 0,
  },
  disabled: {
    opacity: 0.5,
  },
});
